export default __webpack_public_path__ + "static/pole-2-img-afb58981c86eaf0b188d6c662feea3e1.png";